<template>
  <v-container
      class="fill-height"
      fluid
      style="padding: 0"
  >
    <v-img
        style="height: 100%;object-fit: cover"
        :src="background"
        class="grey darken-4"
    >
      <div class="action">
        <v-sheet style="max-width: 50%" color="white" elevation="10" class="justify-center">
          <v-card-title>
            <div>
              <h3 class="headline">Behrendt Online Portal</h3>
            </div>
          </v-card-title>
          <v-card-actions class="justify-center">
            <v-btn color="primary" @click.stop="openDashboard">Login</v-btn>
            <v-btn text color="primary" @click.stop="openValidation">Zertifikatsverifizierung</v-btn>
          </v-card-actions>
        </v-sheet>
      </div>
    </v-img>
  </v-container>
</template>

<script>
export default {
  name: "Home",
  data() {
    return {
      background: require("@/assets/background_start.jpg"),
    }
  },
  methods: {
    openValidation() {
      this.$router.push(this.$router.resolve({name: "Validation"}).route.path);
    },
    openDashboard() {
      this.$router.push(this.$router.resolve({name: "CourseList"}).route.path);
    }
  }
}
</script>

<style scoped>
.v-parallax__image {
  transform: none !important;
  width: 100% !important;
}

.action {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
}
</style>
